/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Renderer2, RendererFactory2, ElementRef, Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { IcepanelService } from './icepanel.service';
import { IcepanelComponent } from './icepanel.component';
import { Iceutility } from '../../services/iceutility';
import { IcepanelcontainerSettings, IcepanelcontainerRowSettings, IcepanelSettings, IceexpansionpanelSettings, iceSettings } from 'projects/icemedx-lib/src/components/models/icesettings';

@Component({
  selector: 'icepanelcontainer',
  templateUrl: './icepanelcontainer.component.html',
  styleUrls: ['./icepanelcontainer.component.scss']
})
export class IcepanelContainerComponent implements OnInit {
    private renderer: Renderer2;
    currentExpansionStep: number = 0;
    totalExpansionSteps: number = 0;

    // Input Parameters
    @Input() settings: IcepanelcontainerSettings = new IcepanelcontainerSettings("", []);

    // Panel outputs
    @Output() headerClick: EventEmitter<any> = new EventEmitter<any>();
    // Mat Grid outputs
    @Output() matgridRowClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() matgridColClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() matgridRowActionClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() matgridAddRowButtonClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() tableLazyLoad: EventEmitter<any> = new EventEmitter<any>();
    // Control outputs
    @Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() controlChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() controlClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() keyUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() keydownEnter: EventEmitter<any> = new EventEmitter<any>();
  @Output() keydownTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileUploadSuccessClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileRemoveClick: EventEmitter<any> = new EventEmitter<any>();

    parent: HTMLElement = null;

  constructor(private targetEl: ElementRef, 
      private panelSvc: IcepanelService,
      rendererFactory: RendererFactory2) {
      this.renderer = rendererFactory.createRenderer(null, null);
  }

  registerNewStep(): number {
    this.totalExpansionSteps++;
    return this.totalExpansionSteps - 1;
  }

  ngOnInit() {
    if (!Iceutility.isdefined(this.settings)) {
      this.settings = new IcepanelcontainerSettings("", []);
    }
    if (!Iceutility.isdefined(this.settings.rows)) {
      this.settings.rows = [new IcepanelcontainerRowSettings([])];
    }

    let numberofSteps = 0;
    for (let irow = 0; irow < this.settings.rows.length; irow++) {
      let row: IcepanelcontainerRowSettings = this.settings.rows[irow];
      if (row == null) continue;
      for (let icol = 0; icol < row.columns.length; icol++) {
        if (false == this.isExpansionPanel(row.columns[icol])) continue;
        let col: IceexpansionpanelSettings = <IceexpansionpanelSettings>row.columns[icol];
        if (col == null) continue;
        if (col.stepAssignment < 0) col.stepAssignment = numberofSteps;
        numberofSteps++;
      }
    }
    this.totalExpansionSteps = numberofSteps; 

    if (!Iceutility.isdefined(this.settings.containerId)) {
      this.settings.containerId = "";
    }

    this.currentExpansionStep = this.settings.getStep();

    let containerDiv = this.panelSvc.getContainer(this.targetEl.nativeElement);
    if (containerDiv && this.settings) {
      this.renderer.setAttribute(containerDiv, "id", this.settings.containerId);
    }
  }

  onHeaderActionClick(event) {
    this.headerClick.emit(event);
  }

  onMatGridRowClick(event) {
    this.matgridRowClick.emit(event);
  }

  onMatGridColClick(event) {
    this.matgridColClick.emit(event);
  }

  onMatGridRowActionClick(event) {
    this.matgridRowActionClick.emit(event);
  }

  onMatGridAddRowButtonClick(event) {
    this.matgridAddRowButtonClick.emit(event);
  }
  onTableLazyLoad(event) {
    this.tableLazyLoad.emit(event);
  }

  onButtonClick(event) {
    this.buttonClick.emit(event);
  }

  onControlClick(event) {
    this.controlClick.emit(event);
  }

  onControlChange(event) {
    this.controlChange.emit(event);
  }

  onKeyUp(event) {
    this.keyUp.emit(event);
  }

  onKeydownEnter(event) {
    this.keydownEnter.emit(event);
  }

  onKeydownTab(event) {
    this.keydownTab.emit(event);
  }

  onFileUploadSuccessClick(event) {
    this.fileUploadSuccessClick.emit(event);
  }

  onFileRemoveClick(event) {
    this.fileRemoveClick.emit(event);
  }

  isExpansionPanel(col: any): boolean {
    return col instanceof IceexpansionpanelSettings;
  }

  setStep(index: number) {
    this.currentExpansionStep = index;
  }

  nextStep() {
    this.currentExpansionStep++;
  }

  prevStep() {
    this.currentExpansionStep--;
  }

  isFinalStep(): boolean {
    return this.currentExpansionStep >= this.totalExpansionSteps - 1
  }
}
